// extracted by mini-css-extract-plugin
module.exports = {"SectionA4":"SectionVideo_SectionA4__ERJ1i"};